import { isDomAvailable } from "../lib"

export const gtagger = (eventname: string, data: object) => {
    if (!isDomAvailable()) return

    window.gtag && window.gtag("event", eventname, { ...data })
}